import { $fetch } from 'ofetch'
import type { FetchOptions } from 'ofetch'

interface ApiFetchOptions extends FetchOptions {
    token?: boolean
}

export default defineNuxtPlugin(() => {
    const rc = useRuntimeConfig();
    const tokenCookie = useCookie<string | null>('wad-auth._token.local');

    const readToken = async (): Promise<string | null> => {
        try {
            const auth = (typeof useAuth === 'function') ? useAuth() : null;
            const s = await auth?.getSession?.();
            const t = s?.accessToken || null;
            if(t) {
                return String(t).replace(/^Bearer\s+/i, '');
            }
        } catch {/* ignore */}
        const v = tokenCookie.value;
        return v ? v.replace(/^Bearer\s+/i, '') : null;
    }

    const $api = $fetch.create({
        baseURL: rc.public.wadApiBaseUrl,
        credentials: 'omit', // using Bearer; no cookies needed
        onRequest: async ({ options }: { options: ApiFetchOptions }) => {
            const useToken = options.token !== false;
            if (!useToken) {
                return;
            }

            const token = await readToken();
            if (!token) {
                return;
            }

            const h = new Headers(options.headers as HeadersInit);

            const hasBody = !!options.body;
            const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
            if (hasBody && !isFormData && !h.has('Content-Type')) {
                h.set('Content-Type', 'application/json; charset=UTF-8');
            }

            h.set('Authorization', `Bearer ${token}`);
            options.headers = h;
        },
    })

    return { provide: { api: $api } }
})
